import { useCallback, useEffect, useState } from 'react';
import { getPPAServicePriceConfig } from 'api/ppaOnboarding';
import { IPPAServicePriceConfigResponse } from 'types/ppaOnboarding';
import { message } from 'antd';
import { getPPAServicePriceConfigOPS } from 'api/operation/ppaProvider';

const useGetPPAServicePriceConfig = (states?: string[], isOps?: boolean): [IPPAServicePriceConfigResponse[] | undefined, boolean, (statesVal: string[]) => Promise<void>] => {
    const [data, setData] = useState<IPPAServicePriceConfigResponse[]>();
    const [loading, setLoading] = useState(false);

    const fetch = useCallback(async (statesVal?: string[] | null) => {
        try {
            setLoading(true);
            let res;
            if (isOps) {
                res = await getPPAServicePriceConfigOPS(statesVal || []);
            } else {
                res = await getPPAServicePriceConfig(statesVal || []);
            }
            // const res = await getPPAServicePriceConfig(statesVal || []);
            if (res && !res.error) {
                setData(res.data?.data);
            } else {
                message.error(res?.error);
            }
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    }, [isOps]);

    useEffect(() => {
        fetch(states);
    }, [fetch, states]);

    return [data, loading, fetch];
};

export default useGetPPAServicePriceConfig;
